
import { Component, Vue } from "vue-property-decorator";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
  },
})
export default class EmployerServicesInviteCandidate extends Vue {}
